<template>
  <div class="user-register-nameId">
    <h3>法人注册</h3>
    <p>法定代表人须先注册个人实名账号</p>
    <van-form @submit="onSubmit" class="second-phone-form">
      <van-field
        v-model="legalName"
        name="legalName"
        placeholder="请输入法定代表人姓名"
        class="userType from-field-phone"
        :rules="[{ required: true, message: '请输入姓名' }]"
      />
      <van-field
        name="userCardnum"
        v-model="userCardnum"
        placeholder="请输入法定代表人身份证号码"
        class="userType from-field-phone"
        :rules="[
          { required: true, message: '请输入身份证号码' },
          {
            pattern: idCardReg,
            message: '请输入正确的身份证号码',
          },
        ]"
      />
      <div class="from-button">
        <van-button
          round
          block
          type="info"
          :disabled="!legalName || !userCardnum"
          native-type="submit"
          >下一步</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import { regCheckByCard } from "../../api/user";
import { request } from "../../utils/request";
import { mapActions, mapGetters } from "vuex";

import Vue from "vue";
import { Dialog } from "vant";
import { NumberKeyboard } from "vant";
import { encryptByAES, encryptKey } from "../../api/encryption";

Vue.use(NumberKeyboard);
export default {
  data() {
    return {
      legalName: "",
      userCardnum: "",
      idCardReg:
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
    };
  },
  // computed: {
  //   ...mapGetters({ getidcard: "idcard", getUserName: "userName" })
  // },
  methods: {
    ...mapActions({
      setIdcard: "user/setIdcard",
      setUserName: "user/setUserName",
    }),
    onSubmit(values) {
      regCheckByCard({
        userName: values.legalName,
        userCardnum: encryptByAES(values.userCardnum, encryptKey),
      })
        .then((res) => {
          if (res.respCode == "SGACU080") {
            //已注册个人信息
            this.setIdcard(this.userCardnum); //存身份证号
            this.setUserName(this.legalName); //存姓名
            console.log("身份证号存在", this.legalName);
            this.$router.push("/legalRegisterFinal");
          } else {
            if (res.respCode == "00000000") {
              //未注册个人信息
              Dialog.confirm({
                title: "提示",
                closeOnClickOverlay: true,
                confirmButtonText: "去注册",
                message: "法定代表人请先完成个人用户注册",
              }).then(() => {
                // on 跳转自然人注册
                this.setIdcard(this.userCardnum); //存身份证号
                this.setUserName(this.legalName); //存姓名
                this.$router.push("/legalPhoneNum");
              });
            } else {
              //实名信息不合法
              this.$toast(res.respMsg);
            }
          }
        })
        .catch((err) => {
          this.$toast({
            message: err,
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.user-register-nameId {
  height: 100vh;
  background-color: #ffffff;
  padding: 20px 20px 0px 20px;
  box-sizing: border-box;
  h3 {
    font-size: 0.8rem;
    color: #333333;
    margin-bottom: 5px;
    margin-top: 30px;
    font-weight: 550;
  }
  p {
    font-size: 0.4rem;
    color: #999999;
    letter-spacing: 1.5px;
    margin-top: 15px;
  }
  .second-phone-form {
    margin-top: 20px;
  }
  .from-field-phone {
    font-size: 0.4rem;
    padding: 15px 0px;
    line-height: 25px;
    box-sizing: border-box;
  }
  .userType {
    font-size: 0.4rem;
    padding-left: 0;
  }
  .van-cell:not(:last-child)::after {
    border: none;
  }
  .van-cell {
    border-bottom: 0.02667rem solid #ebedf0;
  }
  .from-button {
    width: 100%;
    border-radius: 5px;
    button {
      border-radius: 3px;
      margin-top: 20px;
      height: 50px;
    }
  }
  /deep/ .van-button--disabled {
    background-color: #ebebeb;
    border-color: #ebebeb;
    opacity: 1;
  }
}
</style>